import axios from "axios"

import { apiDomain } from "../../store/constants"

const Fundamental = {
    storeFundamental (data) {
        return axios({
            url: apiDomain + `api/form-fund`,
            method: 'POST',
            data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updateFundamental (data) {
        return axios({
            url: apiDomain + `api/form-fund/` + data.id,
            method: 'PUT',
            data: data.payload
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    deleteFundamental (id) {
        return axios({
            url: apiDomain + `api/form-fund/` + id,
            method: 'DELETE'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getFundamentalList (params) {
        return axios({
            url: apiDomain + `api/form-fund`,
            method: 'GET',
            params
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getEditMasterFundamental (id) {
        return axios({
            url: apiDomain + `api/form-fund/` + id,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getEditMasterFundamentalCreate (params) {
        return axios({
            url: apiDomain + `api/form-fund/create`,
            method: 'GET',
            params
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default Fundamental